angular.module('impactx.basket').controller('BasketItemDeletionCtrl', [
    '$scope',
    '$mdDialog',
    'warning',
    'saveLabel',
    'abortLabel',
    'themeFactory',
    'positions',
    'message',
    'otherPositions',
    'otherMessage',
    BasketItemDeletionCtrl]);

function BasketItemDeletionCtrl($scope, $mdDialog, warning, saveLabel, abortLabel, themeFactory, positions, message, otherPositions, otherMessage)
{
    $scope.warning = warning;
    $scope.positions = positions;
    $scope.otherPositions = otherPositions;
    $scope.message = message;
    $scope.otherMessage = otherMessage;
    $scope.saveLabel = saveLabel;
    $scope.abortLabel = abortLabel;
    $scope.theme = themeFactory.getTheme();

    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.answer = function ()
    {
        $mdDialog.hide();
    };
}